export default __webpack_public_path__ + "media/images/solicitors-image-6abbe715cbb89e4474106b5d81581d12.svg";